import React from 'react';
import { Activity, Stethoscope, Sparkles, Smile, Shield, ArrowRight } from 'lucide-react';
import './Treatments.css';

const treatments = [
  {
    icon: Activity,
    title: 'Dental Implants',
    description: 'Permanent solutions for missing teeth with natural-looking results.'
  },
  {
    icon: Stethoscope,
    title: 'Root Canal',
    description: 'Painless treatment to save infected teeth and restore oral health.'
  },
  {
    icon: Sparkles,
    title: 'Cosmetic Dentistry',
    description: 'Transform your smile with veneers, whitening, and bonding.'
  },
  {
    icon: Smile,
    title: 'Orthodontics',
    description: 'Straighten teeth with modern braces and clear aligners.'
  },
  {
    icon: Shield,
    title: 'Preventive Care',
    description: 'Regular check-ups and cleanings to maintain optimal oral health.'
  },
  {
    icon: Sparkles,
    title: 'Teeth Whitening',
    description: 'Professional whitening for a brighter, more confident smile.'
  }
];

const Treatments = () => {
  const handleLearnMore = () => {
    const whatsappNumber = '919959975995';
    const message = 'Hi, I would like to know more about your dental treatments.';
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section id="treatments" className="treatments-section section-padding">
      <div className="container">
        <div className="treatments-header fade-in">
          <h2 className="heading-1">Our Treatments</h2>
          <div className="section-divider"></div>
          <p className="body-large treatments-subtitle">
            Comprehensive dental care tailored to your needs
          </p>
        </div>

        <div className="treatments-grid">
          {treatments.map((treatment, index) => {
            const Icon = treatment.icon;
            return (
              <div key={index} className="treatment-card fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="treatment-icon-wrapper">
                  <Icon size={32} className="treatment-icon" />
                </div>
                <h3 className="heading-3">{treatment.title}</h3>
                <p className="body-regular">{treatment.description}</p>
                <button className="treatment-link" onClick={handleLearnMore}>
                  Learn More <ArrowRight size={16} />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Treatments;